module.exports = __webpack_public_path__ + "media/images/india-president-d3d319947882b0f2855625d10750ddc4.svg";